import { React, useState, useEffect, useRef } from "react";
import { FaBars, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { ImCross } from "react-icons/im";
import Logo from "../../Assets/Navbar/Logo.png";
import TopNav from "./TopNav";

const BottomNavbar = () => {
  // Header
  const [isISODropdownDesktop, setIsISODropdownDesktop] = useState(false);
  const [isComplianceDropdownDesktop, setIsComplianceDropdownDesktop] =
    useState(false);
  const [isISODropdownMobile, setIsISODropdownMobile] = useState(false);
  const [isComplianceDropdownMobile, setIsComplianceDropdownMobile] =
    useState(false);
  const [mobileView, setMobileView] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isoDropdownRef = useRef(null);
  const complianceDropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // Close mobile menu
  const onClose = () => {
    setMobileView(false);
    setIsISODropdownMobile(false);
    setIsComplianceDropdownMobile(false);
  };

  // Menu items
  const menuItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Us" },
    { path: "", label: "ISO Certificates" },
    { path: "", label: "Compliance Certificates" },
    { path: "/payments", label: "Pay Now" },
    { path: "/apply-for-franchise", label: "Apply for Franchise" },
  ];

  const isoCertificatesItems = [
    { path: "/iso-9001:2015", label: "ISO 9001:2015" },
    { path: "/iso-14001:2015", label: "ISO 14001:2015" },
    { path: "/iso-45001:2018", label: "ISO 45001:2018" },
    { path: "/iso-22000:2018", label: "ISO 22000:2018" },
    { path: "/iso-27001:2013", label: "ISO 27001:2013" },
    { path: "/iso-50001:2011", label: "ISO 50001:2011" },
    { path: "/iso-13485:2016", label: "ISO 13485:2016" },
    { path: "/iso-29990:2010", label: "ISO 29990:2010" },
    { path: "/iso-20000-1:2018", label: "ISO 20000-1:2018" },
  ];

  const complianceCertificatesItems = [
    { path: "/gmp", label: "GMP Compliance" },
    { path: "/iatf16949:2016", label: "IATF 16949:2016 Compliance" },
    { path: "/kosher", label: "KOSHER Compliance" },
    { path: "/haccp", label: "HACCP Compliance" },
    { path: "/ce", label: "CE Compliance" },
    { path: "/sa8000", label: "SA 8000 Compliance" },
    { path: "/organic", label: "ORGANIC Compliance" },
    { path: "/rohs", label: "ROHS Compliance" },
    { path: "/halal", label: "HALAL Compliance" },
  ];

  const isActive = (path) => location.pathname === path;

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isoDropdownRef.current &&
        !isoDropdownRef.current.contains(event.target)
      ) {
        setIsISODropdownDesktop(false);
      }
      if (
        complianceDropdownRef.current &&
        !complianceDropdownRef.current.contains(event.target)
      ) {
        setIsComplianceDropdownDesktop(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close mobile menu when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        onClose();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <TopNav />
      {/* Navbar */}
      <nav className="w-full bg-white shadow-lg sticky top-0 z-40">
        <div className="px-4 md:px-10 flex justify-between items-center py-1">
          <div className="flex-shrink-0">
            <img
              src={Logo}
              alt="Logo"
              className="h-10 xs:h-12 sm:h-14 md:h-16 lg:h-20 xl:h-24 cursor-pointer transition-transform duration-300 hover:scale-105"
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-2 xl:space-x-4">
            <ul className="flex space-x-1 xl:space-x-2 2xl:space-x-4">
              {menuItems.map((item) => (
                <li key={item.label} className="relative group">
                  {item.label === "ISO Certificates" ? (
                    <div ref={isoDropdownRef} className="relative">
                      <button
                        onMouseEnter={() => setIsISODropdownDesktop(true)}
                        onMouseLeave={() => setIsISODropdownDesktop(false)}
                        className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-2 lg:py-3 px-2 lg:px-3 xl:px-4 rounded-full text-xs lg:text-sm font-medium shadow-md transition-all duration-300 flex items-center space-x-1 whitespace-nowrap"
                      >
                        <span>{item.label}</span>
                        {isISODropdownDesktop ? (
                          <FaChevronUp size={10} className="lg:w-3 lg:h-3" />
                        ) : (
                          <FaChevronDown size={10} className="lg:w-3 lg:h-3" />
                        )}
                      </button>

                      {isISODropdownDesktop && (
                        <div
                          className="absolute left-0 mt-0 w-56 lg:w-64 xl:w-72 bg-white rounded-b-md shadow-xl z-50 border-t-2 border-[#29AAE1] animate-fadeIn max-h-80 lg:max-h-96 overflow-y-auto"
                          onMouseEnter={() => setIsISODropdownDesktop(true)}
                          onMouseLeave={() => setIsISODropdownDesktop(false)}
                        >
                          <div className="py-2">
                            {isoCertificatesItems.map((isoItem) => (
                              <button
                                key={isoItem.path}
                                onClick={() => {
                                  navigate(isoItem.path);
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                  setIsISODropdownDesktop(false);
                                }}
                                className={`block w-full text-left px-4 lg:px-6 py-2 lg:py-3 text-xs lg:text-sm transition-colors duration-200 ${
                                  isActive(isoItem.path)
                                    ? "bg-[#0070a8] text-white"
                                    : "hover:bg-gray-100"
                                }`}
                              >
                                {isoItem.label}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : item.label === "Compliance Certificates" ? (
                    <div ref={complianceDropdownRef} className="relative">
                      <button
                        onMouseEnter={() =>
                          setIsComplianceDropdownDesktop(true)
                        }
                        onMouseLeave={() =>
                          setIsComplianceDropdownDesktop(false)
                        }
                        className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-2 lg:py-3 px-2 lg:px-3 xl:px-4 rounded-full text-xs lg:text-sm font-medium shadow-md transition-all duration-300 flex items-center space-x-1 whitespace-nowrap"
                      >
                        <span>{item.label}</span>
                        {isComplianceDropdownDesktop ? (
                          <FaChevronUp size={10} className="lg:w-3 lg:h-3" />
                        ) : (
                          <FaChevronDown size={10} className="lg:w-3 lg:h-3" />
                        )}
                      </button>

                      {isComplianceDropdownDesktop && (
                        <div
                          className="absolute left-0 mt-0 w-56 lg:w-64 xl:w-72 bg-white rounded-b-md shadow-xl z-50 border-t-2 border-[#29AAE1] animate-fadeIn max-h-80 lg:max-h-96 overflow-y-auto"
                          onMouseEnter={() =>
                            setIsComplianceDropdownDesktop(true)
                          }
                          onMouseLeave={() =>
                            setIsComplianceDropdownDesktop(false)
                          }
                        >
                          <div className="py-2">
                            {complianceCertificatesItems.map((certItem) => (
                              <button
                                key={certItem.path}
                                onClick={() => {
                                  navigate(certItem.path);
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                  setIsComplianceDropdownDesktop(false);
                                }}
                                className={`block w-full text-left px-4 lg:px-6 py-2 lg:py-3 text-xs lg:text-sm transition-colors duration-200 ${
                                  isActive(certItem.path)
                                    ? "bg-[#0070a8] text-white"
                                    : "hover:bg-gray-100"
                                }`}
                              >
                                {certItem.label}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        navigate(item.path);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-2 lg:py-3 px-2 lg:px-3 xl:px-4 rounded-full text-xs lg:text-sm font-medium shadow-md transition-all duration-300 whitespace-nowrap"
                    >
                      {item.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
            <button
              onClick={() => navigate("/contact")}
              className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-2 lg:py-3 px-2 lg:px-3 xl:px-4 rounded-full text-xs lg:text-sm font-bold shadow-md transition-all duration-300 whitespace-nowrap"
            >
              CONTACT US
            </button>
          </div>

          {/* Tablet Menu (Medium screens) */}
          <div className="hidden md:flex lg:hidden items-center space-x-2">
            <button
              onClick={() => setMobileView(!mobileView)}
              className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-2 px-4 rounded-full text-sm font-medium shadow-md transition-all duration-300 flex items-center space-x-2"
            >
              <span>Menu</span>
              <FaBars className="text-sm" />
            </button>
            <button
              onClick={() => navigate("/contact")}
              className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-2 px-4 rounded-full text-sm font-bold shadow-md transition-all duration-300"
            >
              CONTACT US
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 p-2 hover:text-[#0070a8] transition-colors duration-300"
            onClick={() => setMobileView(!mobileView)}
          >
            <FaBars className="text-xl sm:text-2xl" />
          </button>
        </div>
      </nav>

      {/* Mobile/Tablet Menu */}
      {mobileView && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 lg:hidden"
          onClick={onClose}
        >
          <div
            ref={mobileMenuRef}
            className="absolute top-0 right-0 h-full w-full xs:w-5/6 sm:w-4/5 md:w-3/5 bg-white shadow-xl transform transition-transform"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-3 sm:p-4 flex justify-between items-center border-b">
              <img
                src={Logo}
                alt="Logo"
                className="h-8 sm:h-10 cursor-pointer"
                onClick={() => {
                  navigate("/");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  onClose();
                }}
              />
              <button
                onClick={onClose}
                className="text-gray-500 p-2 hover:text-gray-700 transition-colors duration-300"
              >
                <ImCross className="text-base sm:text-lg" />
              </button>
            </div>
            <div className="p-3 sm:p-4 overflow-y-auto h-[calc(100%-60px)] sm:h-[calc(100%-68px)]">
              <ul className="space-y-2">
                {menuItems.map((item) => (
                  <li key={item.label}>
                    {item.label === "ISO Certificates" ? (
                      <div>
                        <button
                          onClick={() =>
                            setIsISODropdownMobile(!isISODropdownMobile)
                          }
                          className="bg-gradient-to-r from-[#0070a8] to-[#023955] text-white py-3 sm:py-4 px-3 sm:px-4 rounded-full w-full flex justify-between items-center shadow-md text-sm sm:text-base"
                        >
                          <span>{item.label}</span>
                          {isISODropdownMobile ? (
                            <FaChevronUp size={12} className="sm:w-4 sm:h-4" />
                          ) : (
                            <FaChevronDown
                              size={12}
                              className="sm:w-4 sm:h-4"
                            />
                          )}
                        </button>
                        {isISODropdownMobile && (
                          <div className="ml-2 sm:ml-4 space-y-1 mt-1">
                            {isoCertificatesItems.map((isoItem) => (
                              <button
                                key={isoItem.path}
                                onClick={() => {
                                  navigate(isoItem.path);
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                  onClose();
                                }}
                                className="block w-full text-left py-2 sm:py-3 px-3 sm:px-4 rounded text-sm sm:text-base hover:bg-gray-100 transition-colors duration-200"
                              >
                                {isoItem.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : item.label === "Compliance Certificates" ? (
                      <div>
                        <button
                          onClick={() =>
                            setIsComplianceDropdownMobile(
                              !isComplianceDropdownMobile
                            )
                          }
                          className="bg-gradient-to-r from-[#0070a8] to-[#023955] text-white py-3 sm:py-4 px-3 sm:px-4 rounded-full w-full flex justify-between items-center shadow-md text-sm sm:text-base"
                        >
                          <span>{item.label}</span>
                          {isComplianceDropdownMobile ? (
                            <FaChevronUp size={12} className="sm:w-4 sm:h-4" />
                          ) : (
                            <FaChevronDown
                              size={12}
                              className="sm:w-4 sm:h-4"
                            />
                          )}
                        </button>
                        {isComplianceDropdownMobile && (
                          <div className="ml-2 sm:ml-4 space-y-1 mt-1">
                            {complianceCertificatesItems.map((certItem) => (
                              <button
                                key={certItem.path}
                                onClick={() => {
                                  navigate(certItem.path);
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                  onClose();
                                }}
                                className="block w-full text-left py-2 sm:py-3 px-3 sm:px-4 rounded text-sm sm:text-base hover:bg-gray-100 transition-colors duration-200"
                              >
                                {certItem.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <button
                        onClick={() => {
                          navigate(item.path);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                          onClose();
                        }}
                        className="bg-gradient-to-r from-[#0070a8] to-[#023955] text-white py-3 sm:py-4 px-3 sm:px-4 rounded-full w-full shadow-md text-sm sm:text-base"
                      >
                        {item.label}
                      </button>
                    )}
                  </li>
                ))}
                <li className="mt-4 sm:mt-6">
                  <button
                    onClick={() => {
                      navigate("/contact");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      onClose();
                    }}
                    className="w-full bg-gradient-to-r from-[#0070a8] to-[#023955] text-white font-medium py-3 sm:py-4 px-4 sm:px-6 rounded-full shadow-md text-sm sm:text-base"
                  >
                    Contact Us
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Animation */}
      <style jsx="true">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out forwards;
        }

        /* Custom breakpoint for extra small screens */
        @media (min-width: 475px) {
          .xs\:h-12 {
            height: 3rem;
          }
          .xs\:w-5\/6 {
            width: 83.333333%;
          }
        }
      `}</style>
    </>
  );
};

export default BottomNavbar;
